import Switch from '@mui/material/Switch'
import { Grid, Box, CircularProgress, Skeleton } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import Dropdown from 'react-bootstrap/Dropdown'
import Button from '@mui/material/Button'
import VerifiedIcon from '@mui/icons-material/Verified';
import { v4 as uuidv4 } from 'uuid';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import NavBar from '../../structure/NavBar'
import Form from 'react-bootstrap/Form'
import Pagination from '@mui/material/Pagination'
import InputGroup from 'react-bootstrap/InputGroup'
import NoDataImg from '../../../assets/img/no-data.gif'
import { NavBarTop } from '../../structure/NavBarTop'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useCallback, useEffect, useReducer, useState } from 'react'
import Image from '../../custom/Image'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateTopHeader,
  uplodateLoading,
  updateVideos,
  clearVideosCache,
  updateSingleVideoStatus,
  updateMultipleVideosRewarded
} from '../../../redux/features/common/commonSlice'
import {
  selectVideosPages,
  selectVideosIsLoaded,
  selectVideosPagerecord
} from '../../../redux/features/common/selectors'
import { ViewDetails } from './ViewDetails'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
// import { toast } from 'react-hot-toast'
import Utils from '../../constants/Utils'
import { FullImageView } from '../../custom/FullImageView'
import { GiveRewardOnVideo } from '../../custom/GiveRewardOnVideo';
import { VideoRewardCard } from './VideoRewardCard';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom'; // Added useSearchParams and useNavigate



import { AppBar, Toolbar, IconButton, Typography, Divider, Menu, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import LinkIcon from '@mui/icons-material/Link';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { PlayVideoInModal } from '../../custom/PlayVideoInModal';
import { EditVideo } from './EditVideo';

const dropdownToggleStyle = {
  backgroundColor: 'white',
  color: 'black',
  border: '1px solid #cad1d7',
  boxShadow: 'none',
  transform: 'none',
  width: '100%',
  textAlign: 'left'
}

const dropdownMenuStyle = {
  zIndex: 1300,
  maxHeight: 280,
  overflowY: 'auto'
}


const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const VideoList = props => {
  const location = useLocation();
  const userId = location.state?.userId;

  const [goToPage, setGoToPage] = useState('');

  const handleGoToPage = () => {
    let pageNum = parseInt(goToPage, 10);

    if (!pageNum || pageNum < 1) {
      showToast("Please enter a valid page number");
      return;
    }

    if (pageNum > pagerecord.totalPages) {
      showToast(`Page must be between 1 and ${pagerecord.totalPages}`);
      return;
    }

    setPage(pageNum);
    navigate(`?page=${pageNum}`, { replace: true });
    setCallAPi(uuidv4());
  };




  useEffect(() => {
    if (userId) {
      setSearchText(userId); // set search text to userId
      fetchVideosByUser(userId); // only fetch videos of this user
    }
  }, [userId]);

  const fetchVideosByUser = async (userId) => {
    try {
      dispatch(clearVideosCache())
      setListLoading(true)
      
      const postJson = {
        page: 0,
        limit: 12,
        sort: "createdAt",
        order: false,
        searchTxt: userId,
        videoType: true,
        active: true,
        isDraft: false
      };

      const res = await ApiCaller.post(postJson, urls.videoList, userData?.access_token);
      const response = await res?.response.json();

      if (response?.status === 200) {
        setListLoading(false)
        const items = (response?.data?.items || []).filter((item) => !item?.isDraft)
        const newPagerecord = {
          totalItems: response?.data?.totalItems,
          totalPages: response?.data?.totalPages,
          pageNumber: 1,
          pageSize: 12,
          searchText: userId
        }
        dispatch(updateVideos({ pageNumber: 1, datalist: items, pagerecord: newPagerecord }))
      } else {
        setListLoading(false)
        showDangerToast(response?.message || "No videos found");
      }
    } catch (error) {
      setListLoading(false)
      showDangerToast(error?.message || "Something went wrong");
    }
  };


  // const fetchVideosByUser = async (userId) => {
  //   try {
  //     const postJson = { userId };
  //     const res = await ApiCaller.post(postJson, urls.videoList, userData?.access_token);
  //     const response = await res?.response.json();

  //     if (response?.status == 200) {
  //       setDatalist(response?.data?.items || []);
  //       setPagerecord({
  //         totalItems: response?.data?.totalItems,
  //         totalPages: response?.data?.totalPages,
  //         pageNumber: 1,
  //         pageSize: 12
  //       });

  //     } else {
  //       console.log("2000")
  //       showDangerToast(response.message);
  //     }
  //   } catch (error) {
  //     showDangerToast(error.message);
  //   }
  // };




  const [showVideoReward, setShowVideoReward] = useState(true)
  // Use URL query parameters for persistence across refreshes
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialPage = parseInt(searchParams.get('page')) || 1;

  const [page, setPage] = useState(initialPage)
  const { formatDate } = Utils();
  const [callAPi, setCallAPi] = useState('')

  const pages = useSelector(selectVideosPages)
  const datalist = pages[page] || []
  const isLoaded = useSelector(selectVideosIsLoaded)
  const pagerecord = useSelector(selectVideosPagerecord)
  const [pendingUpdates, setPendingUpdates] = useState(null)

  const [fullSizePreview, setFullSizePreview] = useState(false)
  const [imageUrl, setImageUrl] = useState(false)
  const LOADING_ENABLE = useSelector(state => state?.loading)
  const [listLoading, setListLoading] = useState(false)
  const [sort_type, setSortType] = useState('createdAt')
  const [searchText, setSearchText] = useState("")
  const [sort_order, setSortOrder] = useState(false)
  const [showViewDetails, setShowViewDetails] = useState(false)
  const [showEditVideo, setShowEditVideo] = useState(false)
  const [showGiveReward, setShowGiveReward] = useState(false)
  const [selectedVideoDetails, setSelectedVideoDetails] = useState({})
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
  const [mediaDropDownText, setMediaDropDownText] = useState('VIDEO')
  const [mediaUIChange, setMediaUIChange] = useState(true)
  const [activeInActiveStatus, setActiveInActiveStatus] = useState(true)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [languageFilterData, setLanguageFilterData] = useState([])
  const [languageDropdownText, setLanguageDropdownText] = useState({ label: 'Select Language', value: '' })
  const dispatch = useDispatch()
  const [edit, setEdit] = useState(false)
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedVideoData, setSelectedVideoData] = useState([]);
  const [active, setActive] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [view, setView] = useState(false)
  const userData = useSelector(state => state?.userData)
  const [showPlayVideoModal, setShowPlayVideoModal] = useState(false)
  const [videoSrc, setVideoSrc] = useState('')
  const [activeVideoIndex, setActiveVideoIndex] = useState(0)
  const [previewVideo, setPreviewVideo] = useState(null)

  const isPreviewableItem = (item) =>
    Boolean(item?.link) || (Array.isArray(item?.images) && item.images.length > 0)

  const getVideoPlayableList = () => (datalist || []).filter(isPreviewableItem)

  const resolvePreviewVideoSrc = (item) => item?.link || ''

  const openVideoAtIndex = (index) => {
    const list = getVideoPlayableList()
    if (index < 0 || index >= list.length) return
    const video = list[index]
    setActiveVideoIndex(index)
    setPreviewVideo(video)
    setVideoSrc(resolvePreviewVideoSrc(video))
    setShowPlayVideoModal(true)
  }

  const handleVideoIndexChange = (index) => {
    const list = getVideoPlayableList()
    if (index < 0 || index >= list.length) return
    const video = list[index]
    setActiveVideoIndex(index)
    setPreviewVideo(video)
    setVideoSrc(resolvePreviewVideoSrc(video))
  }
  const [video, setVideos] = useState('')
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [globalSettingData, setGlobalSettingData] = useState({})
  const [showAddFontStyle, setShowAddFontStyle] = useState(false)
  const [fontStyleFormData, setFontStyleFormData] = useReducer(
    (fontStyleFormData, newItem) => {
      return { ...fontStyleFormData, ...newItem }
    },
    {
      id: '',
      assetName: '',
      type: '',
      description: '',
      coverImageUrl: '',
      remotePackageUrl: ''
    }
  )

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let activePermission = true;

  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '9') {
        return element
      }
    })?.permissions
    viewPermission = currentModulePermission.find((element) => {
      if (element.name === 'VIEW') {
        return element
      }
    }).isEnable
    activePermission = currentModulePermission.find((element) => {
      if (element.name === 'ACTIVE') {
        return element
      }
    }).isEnable
  }




  const handlePauseVideo = () => {
    setShowPlayVideoModal(false)
    setVideoSrc('')
    setPreviewVideo(null)
    setActiveVideoIndex(0)
  }

  /** Open full-screen preview. Accepts a video object (grid) or a URL string (legacy). */
  const handlePlayVideo = (videoOrUrl) => {
    if (videoOrUrl && typeof videoOrUrl === 'object') {
      const list = getVideoPlayableList()
      const idx = list.findIndex((v) => v.id === videoOrUrl.id)
      if (idx >= 0) {
        openVideoAtIndex(idx)
        return
      }
      setPreviewVideo(videoOrUrl)
      setVideoSrc(resolvePreviewVideoSrc(videoOrUrl))
      setActiveVideoIndex(0)
    } else {
      setPreviewVideo(null)
      setVideoSrc(videoOrUrl || '')
      setActiveVideoIndex(0)
    }
    setShowPlayVideoModal(true)
  }


  const handleCardClick = (video, event) => {
    let videoId = video?.id;
    let chips = globalSettingData?.videoRewardDefaultPrice ? globalSettingData?.videoRewardDefaultPrice : 0;
    let ownerId = video?.profileDetails?.id;
    if (event.ctrlKey || event.metaKey) {
      // Multi-selection
      setSelectedIds((prev) => {
        const exists = prev.some((item) => item.videoId === video?.id);
        const localSelectedIds = exists
          ? prev.filter((item) => item.videoId !== video?.id)
          : [...prev, { videoId, ownerId, chips }];
        return localSelectedIds;
      });
    } else {
      // Single selection
      setSelectedIds((prev) => {
        const exists = prev.some((item) => item.videoId === video?.id);
        const localSelectedIds = exists ? [] : [{ videoId, ownerId, chips }];
        return localSelectedIds;
      });
    }

  };


  const editPrice = (id, userId, price) => {
    let tempSelectedIds = [...selectedIds]; // Clone the array to avoid mutating the original
    let finalUpdatedArray = []; // Initialize the array to store the result
    // Iterate over tempSelectedIds
    for (let videoObj of tempSelectedIds) {
      if (videoObj?.videoId === id) {
        finalUpdatedArray.push({
          videoId: videoObj?.videoId, // Safely access videoId
          ownerId: videoObj?.ownerId, // Safely access ownerId
          chips: parseInt(price) // Assuming price is defined elsewhere in the code
        });
      } else {
        finalUpdatedArray.push(videoObj);
      }
    }
    setSelectedIds(finalUpdatedArray)
  };



  const handleChange = (event, value) => {
    setPage(value)
    navigate(`?page=${value}`, { replace: true });
    setCallAPi(uuidv4())
  }

  useEffect(() => {
    dispatch(updateTopHeader('Video Manager'))
    getSettingList()
    getLanguageFilterData()
  }, [])

  useEffect(() => {
    if (callAPi === '') {
      return;
    }
    const isCacheablePage = page === 1 || page === 2;
    const hasCache = isCacheablePage && !!pages[page];
    getVideoList(hasCache, page);
  }, [page, callAPi]);

  // Keep preview modal footer in sync after list refresh (e.g. edit / reward / status) without closing preview.
  useEffect(() => {
    if (!showPlayVideoModal || !previewVideo?.id || !datalist?.length) return
    const row = datalist.find(v => v?.id === previewVideo.id)
    if (!row) return
    setPreviewVideo(prev => {
      if (!prev || prev.id !== row.id) return prev
      const same =
        prev.active === row.active &&
        prev.rewarded === row.rewarded &&
        prev.videoReward === row.videoReward &&
        prev.videoContentType === row.videoContentType &&
        JSON.stringify(prev.categoryList) === JSON.stringify(row.categoryList) &&
        JSON.stringify(prev.languageList) === JSON.stringify(row.languageList) &&
        JSON.stringify(prev.images) === JSON.stringify(row.images)
      return same ? prev : { ...row }
    })
  }, [datalist, showPlayVideoModal, previewVideo?.id])

  const getSettingList = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.getGlobalSetting
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response?.status == 200 || response?.successful === true) {
        dispatch(uplodateLoading(false))
        console.log(response?.data)
        setGlobalSettingData(response?.data)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const getLanguageFilterData = async () => {
    try {
      const path = urls.languageListKeyValuePair + '?keyword='
      const res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response?.status == 200 || response?.successful === true) {
        const tempArray = (response?.data || []).map((data) => ({
          label: data?.value,
          value: data?.key
        }))
        setLanguageFilterData(tempArray)
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  }


  useEffect(() => {
    const userIdFromState = location?.state?.userId; // 👈 get userId passed from previous page
    if (viewPermission) {
      if (userIdFromState) {
        setSearchText(userIdFromState);
        setListLoading(true);
        
        let postJson = {
          page: 0,
          limit: 12,
          sort: 'createdAt',
          order: false,
          searchTxt: userIdFromState,
          videoType: true,
          active: true,
          isDraft: false,
        };

        ApiCaller.post(postJson, urls.videoList, userData?.access_token)
          .then(async (res) => {
            const response = await res?.response.json();
            if (response?.status == 200 || response?.successful === true) {
              setListLoading(false);
              const items = (response?.data?.items || []).filter((item) => !item?.isDraft)
              const newPagerecord = {
                totalItems: response?.data?.totalItems,
                totalPages: response?.data?.totalPages,
                pageNumber: 1,
                pageSize: 12,
                searchText: userIdFromState
              }
              dispatch(updateVideos({ pageNumber: 1, datalist: items, pagerecord: newPagerecord }))
            } else {
              setListLoading(false);
              showDangerToast(response?.message);
            }
          })
          .catch((err) => {
            setListLoading(false);
            console.error("Error fetching user videos:", err);
            showDangerToast(err?.message);
          });
      } else {
        // Use setCallAPi instead of getVideoList() to respect URL params
        setCallAPi(uuidv4());
      }
    }
  }, [viewPermission]);



  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  // Handle filter click
  const handleFilterClick = useCallback(() => {
    dispatch(clearVideosCache())
    setPage(1);
    navigate(`?page=1`, { replace: true });
    setCallAPi(uuidv4())
    setMediaUIChange(mediaDropDownText === 'VIDEO')
  }, [searchText, mediaDropDownText, activeInActiveStatus, startDate, endDate, languageDropdownText]);

  const getVideoList = async (
    silent = false,
    customPage = page,
    customPageSize = pagerecord.pageSize
  ) => {
    const startDateStr = startDate?.format ? startDate.format('YYYY-MM-DD') : ''
    const endDateStr = endDate?.format ? endDate.format('YYYY-MM-DD') : ''
    const languageName = languageDropdownText?.value
      ? (languageDropdownText?.label || '').trim()
      : ''
    try {
      if (!silent) {
        setListLoading(true)
      }
      let postJson = {
        page: customPage - 1 || 0,
        limit: customPageSize || 12,
        sort: sort_type,
        order: sort_order,
        searchTxt: searchText?.trim(),
        videoType: mediaDropDownText === 'VIDEO' ? true : false,
        active: activeInActiveStatus,
        isDraft: false,
        startDate: startDateStr,
        endDate: endDateStr,
      }
      if (languageName) {
        postJson.language = languageName
      }
      let path = urls.videoList
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response?.status == 200 || response?.successful === true) {
        if (!silent) {
          setListLoading(false)
        }
        const items = (response?.data?.items || []).filter((item) => !item?.isDraft)
        const newPagerecord = {
          totalItems: response?.data?.totalItems || 0,
          totalPages: response?.data?.totalPages || 1,
          pageNumber: customPage,
          pageSize: customPageSize || 12
        }

        if (silent) {
          const cachedList = pages[customPage] || []
          const hasChanges = items.length !== cachedList.length || items.some((item, idx) => {
            const cachedItem = cachedList[idx]
            return (
              !cachedItem ||
              cachedItem.id !== item.id ||
              cachedItem.active !== item.active ||
              cachedItem.rewarded !== item.rewarded ||
              cachedItem.totalViews !== item.totalViews ||
              cachedItem.totalLikes !== item.totalLikes ||
              cachedItem.totalComments !== item.totalComments ||
              cachedItem.updatedAt !== item.updatedAt ||
              cachedItem.caption !== item.caption
            )
          })
          if (hasChanges) {
            setPendingUpdates({ pageNumber: customPage, datalist: items, pagerecord: newPagerecord })
          } else {
            setPendingUpdates(null)
          }
        } else {
          dispatch(updateVideos({ pageNumber: customPage, datalist: items, pagerecord: newPagerecord }))
          setPendingUpdates(null)
        }
      } else {
        if (!silent) {
          setListLoading(false)
        }
        showDangerToast(response.message)
      }
    } catch (error) {
      if (!silent) {
        setListLoading(false)
      }
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleStatusChange = async (event, id) => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.activeInActiveVideo + '?videoId=' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response?.status == 200 || response?.successful === true) {
        dispatch(uplodateLoading(false))
        showToast(response?.message)
        const currentItem = datalist.find(item => item.id === id)
        const currentActive = currentItem ? currentItem.active : false
        setPreviewVideo(prev =>
          prev && prev.id === id ? { ...prev, active: !currentActive } : prev
        )
        dispatch(updateSingleVideoStatus({ id, active: !currentActive }))
        getVideoList(true)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleResetFilter = () => {
    dispatch(clearVideosCache())
    setSearchText('')
    setStartDate(null)
    setEndDate(null)
    setLanguageDropdownText({ label: 'Select Language', value: '' })
    setStatusDropdownText('Select Status')
    setMediaDropDownText('VIDEO')
    setActiveInActiveStatus(null)
    setPage(1);
    navigate(`?page=1`, { replace: true });
    setMediaUIChange(true)
    setCallAPi(uuidv4())
  }


  const handleSubmitReward = async (actionType, videos = selectedIds) => {
    const giveRewardOnVideos = videos?.length ? videos : selectedIds
    if (!giveRewardOnVideos?.length) {
      showDangerToast('Select a video first')
      return
    }
    let jsonBody = {
      type: actionType,
      giveRewardOnVideos
    }
    try {
      dispatch(uplodateLoading(true))
      let path = urls.rewardOnVideoNew
      let res = await ApiCaller.post(jsonBody, path, userData?.access_token)
      const response = await res.response.json()
      if (response?.status == 200 || response?.successful === true) {
        dispatch(uplodateLoading(false))
        showToast(response?.message)
        dispatch(updateMultipleVideosRewarded({ giveRewardOnVideos, actionType }))
        setSelectedVideoData([])
        setSelectedIds([])
        getVideoList(true)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  console.log("props::::::::::::::::::::::", props)

  return (
    <>
      <>
        <NavBar />
        <div className='main-content'>
          <NavBarTop />
          <div className='header'>
            <div className='logo'>
              <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
            </div>
          </div>
          <div className='container-fluid mt--7'>
            <div className='row'>
              <div className='col text-left'>
                <div className='card shadow'>
                  <div className='card-header border-0'>
                    <div className='row align-items-center text-left'>
                      <div className='col'>
                        <h3 className='mb-0'>Video Manager</h3>
                      </div>
                      <div className='col text-right'>
                        <Button variant="contained" onClick={() => setShowVideoReward(!showVideoReward)} endIcon={<CardGiftcardIcon />}>
                          {!showVideoReward ? 'Grid View' : 'Table View'}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div
                    className='card-header border-0 pt-0 video-manager-filters'
                    style={{ overflow: 'visible', position: 'relative', zIndex: 30, maxWidth: '100%' }}
                  >
                    <div className='row align-items-end'>
                      <div className='col-12 col-md-6 col-lg-4 mb-2'>
                        <Form.Label className='mb-1 small text-muted'>Search</Form.Label>
                        <InputGroup style={{ borderRadius: '10px' }}>
                          <Form.Control
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder='User name or ID'
                            onKeyDown={(e) => e.key === 'Enter' && handleFilterClick()}
                          />
                        </InputGroup>
                      </div>
                      <div className='col-6 col-md-3 col-lg-2 mb-2'>
                        <Form.Label className='mb-1 small text-muted'>Status</Form.Label>
                        <Dropdown className='w-100' drop='down'>
                          <Dropdown.Toggle variant='success' style={dropdownToggleStyle} id='video-status-dropdown'>
                            {statusDropdownText}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={dropdownMenuStyle} flip>
                            <Dropdown.Item onClick={() => { setStatusDropdownText('Select Status'); setActiveInActiveStatus(null) }}>
                              Select Status
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => { setStatusDropdownText('Active'); setActiveInActiveStatus(true) }}>
                              Active
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => { setStatusDropdownText('In Active'); setActiveInActiveStatus(false) }}>
                              In Active
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className='col-6 col-md-3 col-lg-2 mb-2'>
                        <Form.Label className='mb-1 small text-muted'>Type</Form.Label>
                        <Dropdown className='w-100' drop='down'>
                          <Dropdown.Toggle variant='success' style={dropdownToggleStyle} id='video-media-dropdown'>
                            {mediaDropDownText}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={dropdownMenuStyle} flip>
                            <Dropdown.Item onClick={() => setMediaDropDownText('VIDEO')}>VIDEO</Dropdown.Item>
                            <Dropdown.Item onClick={() => setMediaDropDownText('IMAGE')}>IMAGE</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className='col-6 col-md-3 col-lg-2 mb-2'>
                        <Form.Label className='mb-1 small text-muted'>Language</Form.Label>
                        <Dropdown className='w-100' drop='down'>
                          <Dropdown.Toggle variant='success' style={dropdownToggleStyle} id='video-language-dropdown'>
                            {languageDropdownText?.label}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={dropdownMenuStyle} flip>
                            <Dropdown.Item onClick={() => setLanguageDropdownText({ label: 'Select Language', value: '' })}>
                              Select Language
                            </Dropdown.Item>
                            {languageFilterData?.map((data) => (
                              <Dropdown.Item key={data.value} onClick={() => setLanguageDropdownText(data)}>
                                {data.label}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      <div className='col-12 col-md-6 col-lg-4 mb-2'>
                        <Form.Label className='mb-1 small text-muted'>Date range</Form.Label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className='d-flex flex-nowrap align-items-center' style={{ gap: 8 }}>
                            <DatePicker
                              disableFuture
                              className='custom-date flex-fill'
                              label='From'
                              value={startDate}
                              onChange={(newValue) => setStartDate(newValue)}
                              maxDate={endDate}
                              slotProps={{ textField: { size: 'small', fullWidth: true } }}
                            />
                            <DatePicker
                              disableFuture
                              className='custom-date flex-fill'
                              label='To'
                              value={endDate}
                              minDate={startDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              slotProps={{ textField: { size: 'small', fullWidth: true } }}
                            />
                          </div>
                        </LocalizationProvider>
                      </div>
                      <div className='col-12 mb-2 d-flex flex-wrap align-items-center justify-content-end' style={{ gap: 8 }}>
                        <Button variant='contained' className='custom-filter-btn' onClick={handleFilterClick}>
                          Filter
                        </Button>
                        <Button variant='outlined' color='inherit' onClick={handleResetFilter}>
                          Reset
                        </Button>
                        {pagerecord?.totalItems != null && !listLoading && (
                          <span className='small text-muted'>
                            {pagerecord.totalItems.toLocaleString()} results
                          </span>
                        )}
                      </div>
                    </div>
                  {pendingUpdates && pendingUpdates.pageNumber === page && (
                    <div className="alert alert-info d-flex justify-content-between align-items-center mb-3 text-dark mx-4" style={{ borderRadius: '8px', borderLeft: '5px solid #11cdef' }}>
                      <span>New video manager updates are available for this page.</span>
                      <Button 
                        variant="contained" 
                        color="info" 
                        size="small" 
                        onClick={() => {
                          dispatch(updateVideos(pendingUpdates));
                          setPendingUpdates(null);
                        }}
                      >
                        Update View
                      </Button>
                    </div>
                  )}
                  </div>
                  {showVideoReward ? <>
                    <div style={{ width: '100%', overflow: 'hidden', padding: '10px', position: 'relative', zIndex: 1 }}>
                      {listLoading ? (
                        <Box sx={{ py: 4 }}>
                          <Box
                            display='flex'
                            alignItems='center'
                            justifyContent='center'
                            gap={2}
                            mb={3}
                          >
                            <CircularProgress size={36} />
                            <Typography variant='body1' color='text.secondary'>
                              Loading videos…
                            </Typography>
                          </Box>
                          <Grid container spacing={3}>
                            {Array.from({ length: 8 }).map((_, index) => (
                              <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
                                <Skeleton variant='rounded' height={220} sx={{ borderRadius: 2 }} />
                                <Skeleton height={28} sx={{ mt: 1 }} />
                                <Skeleton height={20} width='70%' sx={{ mt: 0.5 }} />
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      ) : datalist?.length ? (
                      <Grid container spacing={3} alignItems="flex-start" justifyContent="flex-start">
                        {datalist.map((video, index) => (
                          <Grid item key={video?.id || index} xs={12} sm={6} md={4} lg={3} className='video_grid'>
                            <VideoRewardCard
                              {...video}
                              videoRecord={video}
                              defaultVideoRewardPrice={globalSettingData?.videoRewardDefaultPrice ? globalSettingData?.videoRewardDefaultPrice : 0}
                              eventDetails={props?.eventDetails}
                              eventId={props?.id}
                              positions={props?.criteria}
                              handlePlay={handlePlayVideo}
                              handlePause={handlePauseVideo}
                              menuEnable
                              onRewardAction={(actionType) => handleSubmitReward(actionType, [{
                                videoId: video?.id,
                                ownerId: video?.profileDetails?.id,
                                chips: Number(video?.videoReward || globalSettingData?.videoRewardDefaultPrice || 0)
                              }])}
                              onClick={(e) => handleCardClick(video, e)}
                              editPrice={(price) => editPrice(video.id, video?.profileDetails?.id, price)}
                              videoReward={video?.videoReward}
                              approved={video?.approved}
                              categoryList={video?.categoryList}
                              languageList={video?.languageList}
                              videoContentType={video?.videoContentType}
                              getVideoList={getVideoList}
                              active={video?.active}
                              handleStatusChange={(e) => handleStatusChange(e, video.id)}
                              style={{
                                border: selectedIds?.some((item) => item.videoId === video?.id) ? "2px solid blue" : video?.rewarded ? "1px solid gold" : "1px solid gray",
                                padding: "",
                                cursor: "pointer",
                                borderRadius: "8px",
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                      ) : (
                        <Box textAlign='center' py={6}>
                          <img width='25%' src={NoDataImg} alt='No data' />
                          <Typography fontWeight={600} sx={{ mt: 2 }}>
                            No videos found
                          </Typography>
                        </Box>
                      )}
                    </div>
                    <PlayVideoInModal
                      videoSrc={videoSrc}
                      show={showPlayVideoModal}
                      onHide={() => handlePauseVideo()}
                      videos={getVideoPlayableList()}
                      currentIndex={activeVideoIndex}
                      onIndexChange={handleVideoIndexChange}
                      getVideoUrl={(item) =>
                        item?.link || (item?.images?.length ? '__image__' : null)
                      }
                      getVideoLabel={(video) =>
                        video?.profileDetails?.userName
                          ? `@${video.profileDetails.userName}`
                          : video?.caption || 'Video'
                      }
                      previewVideo={previewVideo}
                      activePermission={activePermission}
                      onViewDetails={(v) => {
                        setSelectedVideoDetails(v)
                        setShowViewDetails(true)
                      }}
                      onEditLanguage={(v) => {
                        setSelectedVideoDetails(v)
                        setShowEditVideo(true)
                      }}
                      onGiveReward={(v) => {
                        setSelectedVideoDetails(v)
                        setShowGiveReward(true)
                      }}
                      onStatusChange={(e, id) => handleStatusChange(e, id)}
                    />
                  </> : <>
                    <div className='table-responsive'>
                      {listLoading ? (
                        <Box display='flex' alignItems='center' justifyContent='center' gap={2} py={8}>
                          <CircularProgress size={36} />
                          <Typography color='text.secondary'>Loading videos…</Typography>
                        </Box>
                      ) : datalist?.length ? (
                        <>
                          <table className='table align-items-center table-flush'>
                            <thead className='thead-light'>
                              <tr>
                                <th scope='col'>S/No.</th>
                                <th scope='col'>User ID</th>
                                <th scope='col'>User Name</th>
                                <th scope='col'>Mobile No.</th>
                                <th scope='col'>{mediaUIChange ? 'Video Link' : 'Posts'}</th>
                                {mediaUIChange ?
                                  <>
                                    <th scope='col'>No. Of Likes</th>
                                    <th scope='col'>No. Of Comments</th>
                                    <th scope='col'>Reports</th>
                                    <th scope='col'>Updated</th>
                                    <th scope='col'>Status</th>
                                    <th scope='col'>Action</th>
                                  </>
                                  : <>
                                    <th scope='col'>Updated</th>
                                    <th scope='col'>Status</th>
                                    <th scope='col'>Action</th>
                                  </>}

                              </tr>
                            </thead>
                            <tbody>
                              {datalist?.map((data, i) => {
                                const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                return (
                                  <>
                                    <tr key={i}>
                                      <td>{startIndex + i + 1}</td>
                                      <td>
                                        {data?.profileDetails?.userRecordId}
                                      </td>
                                      <td>{data?.profileDetails?.userName}</td>
                                      <td>{data?.profileDetails?.mobile}</td>
                                      <td className='truncate'>
                                        {mediaUIChange ? <>
                                          <a target='_blank' href={data?.link} rel="noreferrer">
                                            View
                                          </a>
                                        </> : <>

                                          {data?.images &&
                                            data?.images?.map((shopImg, i) => {
                                              return (
                                                <>
                                                  <img
                                                    src={shopImg}
                                                    style={{
                                                      width: '15%',
                                                      marginRight: '15px',
                                                      borderRadius: '5px',
                                                      cursor: 'pointer'
                                                    }}
                                                    onClick={() => {
                                                      setFullSizePreview(!fullSizePreview)
                                                      setImageUrl(shopImg)
                                                    }}
                                                  ></img>
                                                </>
                                              )
                                            })}
                                        </>}
                                      </td>
                                      {mediaUIChange ?
                                        <>
                                          <td>{data?.totalLikes}</td>
                                          <td>{data?.totalComments}</td>
                                          <td>{data?.totalReports}</td>
                                          <td>{formatDate(data?.updatedAt || data?.createdAt)}</td>
                                          <td>
                                            <Switch
                                              {...label}
                                              checked={data?.active}
                                              disabled={!activePermission}
                                              onChange={(e) => {
                                                if (activePermission) {
                                                  handleStatusChange(e, data?.id)
                                                }
                                              }
                                              }
                                              size='small'
                                            />
                                          </td>
                                          <td className='text-right'>
                                            <div className='dropdown'>
                                              <a
                                                className='btn btn-sm btn-icon-only text-light'
                                                role='button'
                                                data-toggle='dropdown'
                                                aria-haspopup='true'
                                                aria-expanded='false'
                                              >
                                                <i className='fas fa-ellipsis-v' />
                                              </a>
                                              <div
                                                className='dropdown-menu dropdown-menu-right dropdown-menu-arrow'
                                                x-placement='bottom-end'
                                                style={{
                                                  position: 'absolute',
                                                  willChange: 'transform',
                                                  top: '0px',
                                                  left: '0px',
                                                  transform:
                                                    'translate3d(32px, 32px, 0px)'
                                                }}
                                              >
                                                <a
                                                  className='dropdown-item cursor'
                                                  onClick={() => {
                                                    setShowViewDetails(true)
                                                    setSelectedVideoDetails(data)
                                                  }
                                                  }
                                                >
                                                  View Details
                                                </a>
                                                <a
                                                  className='dropdown-item cursor'
                                                  onClick={() => {
                                                    setShowEditVideo(true)
                                                    setSelectedVideoDetails(data)
                                                  }
                                                  }
                                                >
                                                  Edit Language/Category
                                                </a>
                                                {data?.rewarded ? <></> : <a
                                                  className='dropdown-item cursor'
                                                  onClick={() => {
                                                    setShowGiveReward(true)
                                                    setSelectedVideoDetails(data)
                                                  }
                                                  }
                                                >
                                                  Give Reward
                                                </a>}

                                              </div>
                                            </div>
                                          </td>
                                        </>
                                        : <>
                                          <td>{formatDate(data?.updatedAt || data?.createdAt)}</td>
                                          <td>
                                            <Switch
                                              {...label}
                                              checked={data?.active}
                                              onChange={(e) =>
                                                handleStatusChange(e, data?.id)
                                              }
                                              size='small'
                                            />
                                          </td>
                                          <td className='text-right'>
                                            <div className='dropdown'>
                                              <a
                                                className='btn btn-sm btn-icon-only text-light'
                                                role='button'
                                                data-toggle='dropdown'
                                                aria-haspopup='true'
                                                aria-expanded='false'
                                              >
                                                <i className='fas fa-ellipsis-v' />
                                              </a>
                                              <div
                                                className='dropdown-menu dropdown-menu-right dropdown-menu-arrow'
                                                x-placement='bottom-end'
                                                style={{
                                                  position: 'absolute',
                                                  willChange: 'transform',
                                                  top: '0px',
                                                  left: '0px',
                                                  transform:
                                                    'translate3d(32px, 32px, 0px)'
                                                }}
                                              >
                                                <a
                                                  className='dropdown-item cursor'
                                                  onClick={() => {
                                                    setShowViewDetails(true)
                                                    setSelectedVideoDetails(data)
                                                  }
                                                  }
                                                >
                                                  View Details
                                                </a>
                                              </div>
                                            </div>
                                          </td>

                                        </>}


                                    </tr>


                                  </>
                                )
                              })}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <>
                          <>
                            <div className='text-center'>
                              <img width={'25%'} src={NoDataImg}></img>
                              <br />
                              <label style={{ fontWeight: 'bold' }}>No Data Found</label>
                            </div>
                          </>
                        </>
                      )}
                    </div>
                  </>}

                  {/* {datalist && datalist.length > 0 ? (
                    <div className='card-footer py-4'>
                      <Box display="flex" justifyContent="right" alignItems='center'>
                        <span>Total record: {pagerecord?.totalItems}</span>
                        <Pagination
                          className='custom-pagination-class'
                          count={pagerecord?.totalPages}
                          page={page}
                          onChange={handleChange}
                          color='secondary'
                        />
                      </Box>
                    </div>

                    
                  ) : (
                    <></>
                  )} */}

                  {datalist && datalist.length > 0 ? (
                    <div className='card-footer py-4'>
                      <Box display="flex" justifyContent="space-between" alignItems='center'>
                        {/* Left side - total records */}
                        <span>Total record: {pagerecord?.totalItems}</span>

                        {/* Right side - pagination + go to page */}
                        <Box display="flex" alignItems="center" gap={2}>
                          <Pagination
                            className='custom-pagination-class'
                            count={pagerecord?.totalPages}
                            page={page}
                            onChange={handleChange}
                            color='secondary'
                          />

                          {/* Go To Page Input */}
                          <Box display="flex" alignItems="center" gap={1}>
                            <input
                              type="number"
                              className="form-control"
                              style={{ width: "80px", height: "36px" }}
                              value={goToPage}
                              onChange={(e) => setGoToPage(e.target.value)}
                              placeholder="Go to"
                              onKeyDown={(e) => e.key === "Enter" && handleGoToPage()}
                            />
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleGoToPage}
                            >
                              Go
                            </button>
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  ) : null}

                </div>
              </div>
            </div>
          </div>
        </div>
        <ViewDetails
          show={showViewDetails}
          selectedVideoDetails={selectedVideoDetails}
          onHide={() => setShowViewDetails(false)}
        />
        <EditVideo
          show={showEditVideo}
          selectedVideoDetails={selectedVideoDetails}
          getVideoList={getVideoList}
          onHide={() => setShowEditVideo(false)}
        />
        <GiveRewardOnVideo
          show={showGiveReward}
          selectedVideoDetails={selectedVideoDetails}
          getVideoList={getVideoList}
          onHide={() => setShowGiveReward(false)}
        />
        <FullImageView
          src={imageUrl}
          show={fullSizePreview}
          onHide={() => setFullSizePreview(false)}
        />
      </>
    </>
  )
}
